import * as React from "react";

type Props = {
  organizationSlug?: string;
  clusterId?: string;
};

export default function SecretsWarning({ organizationSlug, clusterId }: Props) {
  // Build the secrets management URL if we have the required info
  const secretsUrl =
    organizationSlug && clusterId
      ? `/organizations/${organizationSlug}/clusters/${clusterId}/secrets`
      : null;

  return (
    <div className="alert alert-info mb-2" role="alert">
      <p>
        {"Having trouble with secrets access? Check that your secrets are properly "}
        {secretsUrl ? (
          <strong>
            <a href={secretsUrl}>configured</a>
          </strong>
        ) : (
          <strong>configured</strong>
        )}
        {" and accessible from this job. Review the "}
        <strong>
          <a href="/docs/pipelines/security/secrets/buildkite-secrets" target="_blank">
            secrets documentation
          </a>
        </strong>
        {" for setup guidance."}
      </p>
      <p>
        {"Still need help? Email us at "}
        <strong>
          <a href="mailto:support@buildkite.com">support@buildkite.com</a>
        </strong>
        {/*
         */}
        —we&apos;d be happy to help!
      </p>
    </div>
  );
}
